module.exports = __webpack_public_path__ + "img/vvf.2933d69e.svg";